

























import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Enumerable from "linq";
import { ModelEditableMixin } from "../../system/mixins";
import FormatReferenceDirectoryFilter from "./FormatReferenceDirectoryFilter.vue";
import FormatReferenceFilter from "./FormatReferenceFilter.vue";
import FormatReferenceMasterCodeFilter from "./FormatReferenceMasterCodeFilter.vue";
import FormatReferenceDocumentKindFilter from "./FormatReferenceDocumentKindFilter.vue";
import FormatReferenceTagFilter from "./FormatReferenceTagFilter.vue";
import { FormatReferenceDirectoryFilterParameter, FormatReferenceFilterParameter, FormatReferenceTreeFilterParameter } from ".";
import { WriteMethodTypeValue } from "../../../domain/format";
import { StringFilterParameter } from "../../system/filters";

@Component({
  components: {
    FormatReferenceFilter,
    FormatReferenceMasterCodeFilter,
    FormatReferenceDocumentKindFilter,
    FormatReferenceTagFilter,
    FormatReferenceDirectoryFilter,
  },
})
export default class FormatReferenceTreeFilter extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: FormatReferenceTreeFilterParameter) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: FormatReferenceTreeFilterParameter) => T, defaultValue: T) => T;

  @Prop({ default: false })
  expand: boolean;

  @Prop({ default: false })
  visibleExpired: boolean;

  @Prop({ default: false })
  visibleDeleted: boolean;

  @Prop()
  isDocumentKindSpecified: boolean;

  @Prop({ default: null })
  defaultWriteMethodTypes: WriteMethodTypeValue[];

  data(): any {
    return {
      activeNames: [],
      updatedMasterCode: "",
      updatedDocumentKind: "",
    };
  }
  activeNames: string[];
  updatedMasterCode: string;
  updatedDocumentKind: string;

  get conditionsString(): string {
    const text = Enumerable.from([
      this.containsExpiredConditionString,
      this.containsDeletedConditionString,
      this.directoryNameConditionString,
      this.formatNameConditionString,
      this.masterCodeConditionString,
      this.documentKindConditionString,
      this.tagConditionString,
      this.writeMethodTypeConditionString,
    ])
    .where(t => !!t)
    .toArray()
    .join("");
    return "絞り込み：" + (text ? text : "なし");
  }

  private formatConditionString(name: string, value: string): string {
    return value
      ? (name + "【" + value + "】")
      : "";
  }

  get containsExpiredConditionString(): string {
    return this.formatConditionString(
      "期限切れ",
      (this.visibleExpired && this.containsExpired) ? "含む" : null);
  }

  get containsDeletedConditionString(): string {
    return this.formatConditionString(
      "削除済",
      (this.visibleDeleted && this.containsDeleted) ? "含む" : null);
  }

  get writeMethodTypeConditionString(): string {
    return this.formatConditionString(
      "運用対象外",
      (this.isDefaultWriteMethodTypesSpecified && this.containsUnspecifiedWriteMethodTypes) ? "含む" : null);
  }

  get directoryNameConditionString(): string {
    return this.formatConditionString(
      "フォルダ名称",
      this.directory ? this.directory.name.keyword : null);
  }

  get formatNameConditionString(): string {
    return this.formatConditionString(
      this.$wording.format.name + "名称",
      this.reference ? this.reference.name.keyword : null);
  }

  get masterCodeConditionString(): string {
    return this.formatConditionString(
      "整理番号",
      this.updatedMasterCode);
  }

  get documentKindConditionString(): string {
    return this.formatConditionString(
      this.$wording.format.attributes.name + "種別",
      this.updatedDocumentKind);
  }

  get tagConditionString(): string {
    return this.formatConditionString(
      "タグ",
      this.reference ? this.reference.tag.keyword : null);
  }

  get containsExpired(): boolean {
    return this.readPropertyOrDefault(s => s.reference.containsExpired, false);
  }

  set containsExpired(source: boolean) {
    this.writePropertyWhenValid(s => s.reference.containsExpired = source);
  }

  get containsDeleted(): boolean {
    return this.readPropertyOrDefault(s => s.reference.containsDeleted, false);
  }

  set containsDeleted(source: boolean) {
    this.writePropertyWhenValid(s => s.reference.containsDeleted = source);
  }

  get containsUnspecifiedWriteMethodTypes(): boolean {
    const writeMethodTypeParameters = this.readPropertyOrDefault(s => s.reference.writeMethodTypes, []);
    return !writeMethodTypeParameters || (writeMethodTypeParameters.length === 0);
  }

  set containsUnspecifiedWriteMethodTypes(source: boolean) {
    const writeMethodTypeParameters = source
      ? []
      : Enumerable.from(this.defaultWriteMethodTypes).select(w => new StringFilterParameter(w, false)).toArray();
    this.writePropertyWhenValid(s => s.reference.writeMethodTypes = writeMethodTypeParameters);
  }

  get reference(): FormatReferenceFilterParameter {
    return this.readPropertyOrDefault(s => s.reference, new FormatReferenceFilterParameter());
  }

  set reference(source: FormatReferenceFilterParameter) {
    this.writePropertyWhenValid(s => s.reference = source);
  }

  get directory(): FormatReferenceDirectoryFilterParameter {
    return this.readPropertyOrDefault(s => s.directory, new FormatReferenceDirectoryFilterParameter());
  }

  set directory(source: FormatReferenceDirectoryFilterParameter) {
    this.writePropertyWhenValid(s => s.directory = source);
  }

  get isDefaultWriteMethodTypesSpecified(): boolean {
    return !!this.defaultWriteMethodTypes && (this.defaultWriteMethodTypes.length !== 0);
  }

  @Watch("expand")
  onExpandUpdated(newValue: boolean, oldValue: boolean): void {
    this.activeNames = newValue
      ? ["1"]
      : [];
  }

  @Watch("visibleExpired")
  onContainsExpiredUpdated(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.writePropertyWhenValid(s => s.reference.containsExpired = newValue);
    }
  }

  @Watch("visibleDeleted")
  onContainsDeletedUpdated(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.writePropertyWhenValid(s => s.reference.containsDeleted = newValue);
    }
  }

  clear(): void {
    this.writePropertyWhenValid(s => s.clear());
  }
}
